import PropTypes from "prop-types";

import InfoIcon from "assets/svg/info_small.svg";
import ArrowUpGreen from "assets/svg/bold_up_arrow.svg";

import { numberFormatter } from "helpers/number-formatter";

import styles from "./styles.module.css";

const PriceIndexInfo = ({ listingEstateType, districtReportPriceInfos }) => {
  const { averagePriceForSale, averagePriceForRent, amortization, exchangeRatio, exchangeState } =
    districtReportPriceInfos || {};
  return (
    <div className={styles.infoWrapper}>
      <div className={styles.infoItem}>
        <span className={styles.infoTitle}>Ortalama Kiralık Fiyatı</span>
        <p className={styles.infoDescription}>
          {averagePriceForRent ? `${numberFormatter(averagePriceForRent)} TL` : "-"}
        </p>
      </div>
      <div className={styles.borderBetweenItems} />
      <div className={styles.infoItem}>
        <span className={styles.infoTitle}>Ortalama Satılık Fiyatı</span>
        <p className={styles.infoDescription}>
          {averagePriceForSale ? `${numberFormatter(averagePriceForSale)} TL` : "-"}
        </p>
      </div>
      <div className={styles.borderBetweenItems} />
      <div className={styles.infoItem}>
        <div className={styles.infoTitleWrapper}>
          <span className={styles.infoTitle}>Ortalama Geri Dönüş Süresi</span>
          {/* eslint-disable-next-line */}
          <div tooltip="Satış bedelinin kiraya bölümünden bulunan amortisman süresini ifade eder." flow="down">
            <InfoIcon />
          </div>
        </div>

        <p className={styles.infoDescription}>{amortization ? `${amortization} Yıl` : "-"}</p>
      </div>
      <div className={styles.borderBetweenItems} />
      <div className={styles.infoItem}>
        <span className={styles.infoTitle}>1 Yıllık Değer Değişimi</span>
        {exchangeRatio ? (
          <div className={styles.iconWrapper}>
            <p className={styles.infoDescription}>{`%${exchangeRatio}`}</p>
            {exchangeState === "INCREASING_RATE" ? (
              <ArrowUpGreen />
            ) : (
              <div className={styles.infoIconArrow}>
                <ArrowUpGreen />
              </div>
            )}
          </div>
        ) : (
          <p className={styles.infoDescription}>-</p>
        )}
      </div>
    </div>
  );
};

PriceIndexInfo.propTypes = {
  districtReportPriceInfos: PropTypes.object,
  listingEstateType: PropTypes.string,
};

export default PriceIndexInfo;
